import { lazy } from 'react';

const HomePage = lazy(() => import('../modules/home'));
const LoginPage = lazy(() => import('../modules/login'));
const EmployeeSearchPage = lazy(() => import('../modules/employee-search'));
const EcardDownload = lazy(() => import('../modules/download-ecard'));
const Claims = lazy(() => import('../modules/claims'));
const OtpPage = lazy(() => import('../modules/otp-page'));
const MISReports = lazy(() => import('../modules/mis-reports'));
const PowerBIReportPage = lazy(() => import('../modules/report-embed'));
const ForgotPassword = lazy(() => import('../modules/forgot-password-journey/initiate'));
const ResetPassword = lazy(() => import('../modules/forgot-password-journey/complete'));
export {
  HomePage,
  LoginPage,
  EcardDownload,
  EmployeeSearchPage,
  Claims,
  OtpPage,
  MISReports,
  PowerBIReportPage,
  ForgotPassword,
  ResetPassword
};
